import React from 'react';
import { Link } from 'react-router-dom';
import  ThemeToggle  from './ThemeToggle';
const GlobalNav = () => {
  return (
    <div className="row pt-3"  >
    <div className="col-3">
      <Link to="/" className="text-decoration-none"><img src="/media/pharmacoevidence-logo.png"   className="logo-color w-35" /></Link>
    </div>
    <div className="col-9 text-end">
      <ThemeToggle/>
       <span>&nbsp;&nbsp;&nbsp;</span>
      <Link to="/login" className="ev-btn-blue-fill-round ev-btn-large ev-fs-12 ev-bold-reg"><i className="bi bi-hdd-stack"></i> &nbsp;IAM Console</Link>
      {/* 
      <span>&nbsp;&nbsp;&nbsp;</span>
      <Link to="/admin-login" className="ev-btn-blue-fill-round ev-btn-large ev-fs-12 ev-bold-reg"><i className="bi bi-hdd-stack"></i> &nbsp; Administration</Link>
      */}
      <span>&nbsp;&nbsp;&nbsp;</span>
      <a className="ev-btn-blue-outline-round ev-btn-large ev-fs-11 ev-bold-med" href="https://www.pharmacoevidence.com/">PHARMACOEVIDENCE <i className="bi bi-box-arrow-in-up-right"></i></a>  
    </div>
  </div>
  );
};
export default GlobalNav;